export const LabelText = {
  MANDATORY: ' *',
  TITLE: 'Choose a gift card'
};
